export enum SEARCH_RESULTS {
  LOBBY_ACTIVITY = 1,
  MEDICAL_REFERRAL = 2,
}

export enum SEARCH_RESULTS_TYPE {
  MEDICAL_REFERRAL = 1,
  NOTIFICATIONS = 2,
  CANCELED_MEDICAL_REFERRALS = 3,
  APPLIES = 4,
  LONG_TERM_EQUIPMENT = 5,
  PAYMENTS_AND_DEDUCTIONS = 6,
  UNIVERSAL_REQUEST = 7,
  YOUR_TEAM = 8,
  COMPASS = 9,
  DOCUMENTS = 10,
  PAYSLIPS = 11,
  FORM106 = 12,
  CLAIMS_EVENTS = 13,
  TREATMENTS_ENTITLEMENTS = 14,
  TREATMENTS_ORDERS = 15,
  ELIGIBLE_MEDICATIONS = 16,
  PRESCRIPTIONS_ORDERS = 17,
  AVAILABLE_CONS_EQUIPMENT = 18,
  CONS_EQUIPMENT_ORDERS = 19,
}

export enum SORT_BY {
  ASCENDING = 1,
  DESCENDING = 2,
  SCORE = 3,
}

export enum STATUSES {
  NONE = 0,
  OPENED_IN_SYSTEM = 1,
  UNDER_REVIEW = 4,
  APPROVED = 5,
  ON_HOLD = 7,
  REJECTED = 8,
  FAILED = 9,
  PROCESS = 10,
}
